import { InjectionToken } from '@angular/core';
import { IDrawingsService } from '../../interfaces/services/drawings-service.interface';

export const DRAWINGS_SERVICE = new InjectionToken<IDrawingsService>('DrawingsService');
